import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./EnergyServicesHomeStyles";
import Header from "../components/Header";
import EnergyServicesNavigation from "../components/EnergyServicesNavigation";
import Loading from "../components/Loading";
import PageTitle from "../components/PageTitle";
import UpdatedLozenge from "../components/UpdatedLozenge";
import DailyBreakdown from "../components/DailyBreakdown";
import BreakdownChart from "../components/BreakdownChart";
import AppliancesTitle from "../components/AppliancesTitle";
import AppliancesUsedToday from "../components/AppliancesUsedToday";
import AppliancesMostUsed from "../components/AppliancesMostUsed";
import AppliancesMostCostly from "../components/AppliancesMostCostly";
import PopupWrapper from "../components/PopupWrapper";
import { energyActions } from "../_actions";
import { connect } from "react-redux";

class EnergyServicesHome extends Component {
  constructor(props) {
    super(props);
    let user = JSON.parse(localStorage.getItem("user"));
    const unix = Math.round(+new Date() / 1000);
    this.props.dispatch(energyActions.getTodayStatus(user, unix, "day"));
  }

  render() {
    const { fetchingDetail, detail } = this.props.energy;
    return (
      <div>
        <Header
          title={"My Home"}
          backTitle={"Dashboard"}
          backHref={"/"}
          isHomeView={true}
        />
        {detail.subtitle && (
          <PageTitle title={"Today"} subTitle={detail.subtitle} />
        )}
        <EnergyServicesNavigation {...this.props.location} />
        <div className={css(styles.container)}>
          <PopupWrapper />
          {fetchingDetail && <Loading />}
          {!fetchingDetail && detail.balance && (
            <div>
              <UpdatedLozenge {...detail} />
              <DailyBreakdown {...detail} />
              <BreakdownChart {...this.props} />
              <div className={css(styles.innerNarrow)}>
                <AppliancesTitle time_unit="hour" />
                <AppliancesUsedToday {...detail} />
                <AppliancesMostUsed {...detail} />
                <AppliancesMostCostly {...detail} />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { fetchingDetail } = state.energy;
  const { alert } = state;
  const energy = state.energy;
  return {
    fetchingDetail,
    alert,
    energy
  };
}

export default connect(mapStateToProps)(EnergyServicesHome);
